import React, { useState, useEffect, useCallback } from "react";
import { pb4y as api, producaov2 } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import { Box } from '@material-ui/core';
import { Icon, Pagination } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  ButtonIcon,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/Cupons/Back";

const PocketCupons = (props) => {
  const [cupons, setCupons] = useState([]);
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [count, setCount] = useState([]);

  useEffect(() => {
    loadAuth();

    loadCupons();
  }, [currentPage]);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadCupons = async () => {
    try {
      const response = await api.get(`/admin/cupons/?page=${currentPage}`,{
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`
        }
      });
      let logs = { local: "PocketBook", texto: `listou os cupons` };
      producaov2.post("system_logs", { acao: JSON.stringify(logs) });
      setCupons(response.data);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os cupons", "", "");
    }
  };

  const removeCupom = useCallback(
    (id) => {
      api.delete(`admin/cupons/${id}`).then((res) => {
        const newCupons = [...cupons].filter((cup) => cup.id !== id);
        setCupons(newCupons);
        let logs = {
          local: "PocketBook",
          texto: `deletou o cupom de id=${id}`,
        };
        producaov2.post("system_logs", { acao: JSON.stringify(logs) });
      });
    },
    [cupons]
  );

  return (
    <>
        <Box width="100%" paddingLeft="250px">
        <Box width="100%" padding="1rem">
        <AdminMenu />
        <Content>
          <Back />
          <Title>Cupons</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar cupons"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />

            <CreateButton to="/admin/pocketbook/cupons/criar">
              Criar
            </CreateButton>
          </ContainerInputSearch>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>ID </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Código</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ativo </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Validade </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Num Usos </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Max. uso </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Parceiro </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Funcionalidades{" "}
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {cupons
                .filter((cupom) =>
                  cupom.cupom.toLowerCase().includes(search.toLowerCase())
                )
                .map((cupom, index) => (
                  <SemanticTable.Row>
                    <SemanticTable.Cell>{cupom.id}</SemanticTable.Cell>
                    <SemanticTable.Cell>{cupom.cupom} </SemanticTable.Cell>
                    <SemanticTable.Cell>{cupom.ativo}</SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {cupom.tempo_validade}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>{cupom.usado}</SemanticTable.Cell>
                    <SemanticTable.Cell>{cupom.max_uso}</SemanticTable.Cell>
                    <SemanticTable.Cell>
                      {cupom.isParceiro === 1 ? "Sim" : "Não"}
                    </SemanticTable.Cell>
                    <SemanticTable.Cell>
                      <>
                        <ButtonIcon
                          onClick={() =>
                            window.open(
                              `/admin/pocketbook/cupons/detalhes/${cupom.id}`
                            )
                          }
                        >
                          <Icon name="edit" color={"blue"} />
                        </ButtonIcon>

                        <ButtonIcon onClick={() => removeCupom(cupom.id)}>
                          <Icon name="trash" color={"red"} />
                        </ButtonIcon>
                      </>
                    </SemanticTable.Cell>
                  </SemanticTable.Row>
                ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Content>
      </Box>
      </Box>
    </>
  );
};

export default withRouter(PocketCupons);
